import React, {useContext, useEffect, useState} from 'react'
import {Form, FormControl} from 'react-bootstrap';

import {AppContext} from '../AppContext';
import {tre} from '../trebus'

export default function SelectCustomer({name, caption, value, onChange, className}) {

    const [customers, setCustomers] = useState([]);
    const context = useContext(AppContext);

    /**
     * Cargar las paradas
     */
    const loadCustomers = () => {
        tre.api('GET', '/companies/' + context.idCompany + '/customers', {
            context: context,
            params: {
                rows: 2000
            },
            success: (r) => {

                setCustomers([
                    {
                        id: 0,
                        name: 'Sin cliente'
                    },
                    ...r.data
                ]);

                // Lanzar onChange con el primer valor
                //if (!value && onChange) onChange(r.data[0].id);
            }
        });
    }

    /**
     * Init
     */
    useEffect(() => {
        loadCustomers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
     * El valor cambia
     */
    const handleOnChange = (ev) => {
        if (onChange) onChange({name: name, value: ev.target.value});
    }

    // -----| Render |-----
    return (
        <Form.Group>
            {caption && <Form.Label>{caption}</Form.Label>}
            <FormControl as="select" onChange={handleOnChange} value={value} className={className}>
                {customers && customers.map(customer =>
                    <option value={customer.id} key={customer.id}>{customer.name}</option>
                )}
            </FormControl>
        </Form.Group>
    )
}
	
